import * as _ from 'underscore';

import { GetServerInfoRequest, IGetServerInfoResult } from '../types/GetServerInfoRequest';

import { IHost } from '../types/IHost';
import { IWorkerProcess } from '../../ts/ServerApi/types/IWorkerProcess';
import { Messages } from '../../codegen/Localize';
import { ServerService } from '../../ts/services/ServerService';
import { ServiceLocator } from '../../app/ServiceLocator';
import { toNativePromise } from '../../commonInfra/utils/QUtils';

export namespace ServerInfoService {

  export function fetch(): Promise<IHost[]> {
    return toNativePromise(ServiceLocator.get<ServerService>('ServerService').sendRequest(new GetServerInfoRequest({}))
      .then<IHost[]>((result: IGetServerInfoResult) => {
        return makeHosts(result);
      }));
  }

  // Transform the array of ServerComponentProcesses into an ordered array of Hosts
  function makeHosts(result: IGetServerInfoResult): IHost[] {
    const groupedByHosts: _.Dictionary<IWorkerProcess[]> = _.groupBy(result.processes, 'host');
    const hosts = _.map(result.workerHosts, (hostName: string) => {
      const host: IHost = {
        name: hostName,
        processes: _.groupBy(groupedByHosts[hostName], 'type'),
        isExternal: false,
      };
      return host;
    });

    // External hosts are those that host services but are not part of the cluster.
    const externalHosts = _.keys(groupedByHosts).filter((x: string) => result.workerHosts.indexOf(x) === -1);
    if (externalHosts.length > 0) {
      // We are going to merge all the external hosts into one called 'external'
      const externalProcesses: IWorkerProcess[] = _.flatten(_.map(externalHosts, (hostName: string) => groupedByHosts[hostName]));
      // Mark all the processes as external
      _.forEach(externalProcesses, (x: IWorkerProcess) => x.isExternal = true);
      const externalHost: IHost = {
        name: Messages.externalNodeName(),
        processes: _.groupBy(externalProcesses, 'type'),
        isExternal: true,
      };
      hosts.push(externalHost);
    }

    return hosts;
  }

}

export type ServerInfoService = typeof ServerInfoService;
